var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-priority-view flex-between-wrapper" },
    [
      _c("img", {
        staticClass: "feature-image",
        attrs: { src: "/assets/app/class/priority-frame-bg.png" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "premium-priority-view" }, [
        _c("h3", { staticClass: "view-title" }, [
          _vm._v("Get the support you need, when you need it."),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "view-description" }, [
          _vm._v(
            "Your success is our success. Priority support means your support inquiries will always get answered first. Look at us as an extension of your teaching team!"
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-wrapper" },
          [
            _c("primary-button", { on: { click: _vm.handleClickPlan } }, [
              _vm._v("Choose your plan"),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }